/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dice_roll = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🎲 Roll`)
};

const es_dice_roll = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🎲 Tirar`)
};

const de_dice_roll = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🎲 Würfeln`)
};

const nl_dice_roll = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🎲 Gooien`)
};

const fr_dice_roll = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🎲 Lancer`)
};

const it_dice_roll = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🎲 Lancia`)
};

const pt_br2_dice_roll = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🎲 Rolar`)
};

const pt_dice_roll = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🎲 Lançar`)
};

const ja_dice_roll = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🎲 振る`)
};

const zh_dice_roll = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🎲 掷骰`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dice_roll = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dice_roll(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dice_roll", locale)
	if (locale === "en") return en_dice_roll(inputs)
	if (locale === "es") return es_dice_roll(inputs)
	if (locale === "de") return de_dice_roll(inputs)
	if (locale === "nl") return nl_dice_roll(inputs)
	if (locale === "fr") return fr_dice_roll(inputs)
	if (locale === "it") return it_dice_roll(inputs)
	if (locale === "pt-BR") return pt_br2_dice_roll(inputs)
	if (locale === "pt") return pt_dice_roll(inputs)
	if (locale === "ja") return ja_dice_roll(inputs)
	return zh_dice_roll(inputs)
};